// 2025 Topps Chrome Star Wars The National — GENERATED by pipeline-publish (2026-05-23)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2025-chrome-the-national.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2025-chrome-the-national",
//     name: "2025 Topps Chrome Star Wars The National",
//     shortName: "Chrome The National 2025",
//     year: 2025,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2025",
//     totalCards: 30,
//     description: "Topps 2025 Topps Chrome Star Wars The National trading card set.",
//     color: "#ff4444",
//     accentColor: "#f0c040",
//     dataFile: "2025-chrome-the-national",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SW-1", name: "Darth Vader" },
        { n: "SW-2", name: "Luke Skywalker" },
        { n: "SW-3", name: "Han Solo" },
        { n: "SW-4", name: "Obi-Wan Kenobi" },
        { n: "SW-5", name: "Leia Organa" },
        { n: "SW-6", name: "Chewbacca" },
        { n: "SW-7", name: "The Mandalorian" },
        { n: "SW-8", name: "Grogu" },
        { n: "SW-9", name: "Ahsoka Tano" },
        { n: "SW-10", name: "BB-8" },
        { n: "SW-11", name: "Cassian Andor" },
        { n: "SW-12", name: "Lando Calrissian" },
        { n: "SW-13", name: "General Grievous" },
        { n: "SW-14", name: "Poe Dameron" },
        { n: "SW-15", name: "Qui-Gon Jinn" },
    ],
  },
  {
    id: "autographs",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SW-AA", name: "Adria Arjona Bix Caleen" },
        { n: "SW-AB", name: "Ahmed Best Jar Jar Binks" },
        { n: "SW-AD", name: "Anthony Daniels C-3PO" },
        { n: "SW-AS", name: "Andy Serkis Kino Loy" },
        { n: "SW-EE", name: "Eman Esfandi Ezra Bridger" },
        { n: "SW-GC", name: "Gwendoline Christie Captain Phasma" },
        { n: "SW-GE", name: "Giancarlo Esposito Moff Gideon" },
        { n: "SW-JB", name: "Jennifer Beals Garsa Fwip" },
        { n: "SW-KS", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "SW-MW", name: "Mary Elizabeth Winstead Hera Syndulla" },
        { n: "SW-NP", name: "Natalie Portman Padmé Amidala" },
        { n: "SW-PP", name: "Pedro Pascal The Mandalorian" },
        { n: "SW-RF", name: "Rupert Friend The Grand Inquisitor" },
        { n: "SW-RP", name: "Ray Park Darth Maul" },
        { n: "SW-SB", name: "Stephen Bruner The Modifier" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
